// @internal
import './number-operations';

var fallback = function (url: string)
{
	// Try a new window first, because we don't know if Content-Disposition is used.
	try
	{
		window.open(url);
	}
	catch (ex)
	{
		window.location.href = url;
	}
};

var dispatchEvent = function (type: string, attrs: any)
{
	var e: Event;

	if (document.createEvent)
	{
		e = document.createEvent('Event');

		e.initEvent(type, true, true);
	}
	else
	{
		e = new Event(type);
	}

	(e as any).data = attrs;

	window.dispatchEvent(e);
};

function _download(url: string | Blob, fileName: string | undefined): void
{
	try
	{
		if (url instanceof Blob)
		{
			var blob = url;

			dispatchEvent('beforeDownload', {'blob': blob, 'fileName': fileName});

			if ((window.navigator as any).msSaveOrOpenBlob) // IE
			{
				(window.navigator as any).msSaveOrOpenBlob(blob, fileName);

				dispatchEvent('afterDownload', {'blob': blob, 'fileName': fileName});
			}
			else if (/constructor/i.test((window as any).HTMLElement) || (window as any).safari) // Safari
			{
				var reader = new FileReader();
				reader.onloadend = function ()
				{
					if (reader.result !== null)
					{
						let str;

						if (reader.result instanceof ArrayBuffer)
						{
							// @ts-ignore
							str = String.fromCharCode.apply(null, new Uint16Array(reader.result));
						}
						else
						{
							str = reader.result;
						}

						var url = str.replace(/^data:[^;]*;/, 'data:attachment/file;');

						window.open(url);

						dispatchEvent('afterDownload', {'blob': blob, 'fileName': fileName});
					}
				};

				reader.readAsDataURL(blob);
			}
			else
			{
				var downloadUrl = URL.createObjectURL(blob);
				var a = document.createElement('a');

				a.onclick = function ()
				{
					document.body.removeChild(a);
				};
				(a as any).download = fileName;
				a.href = downloadUrl;

				document.body.appendChild(a);
				a.click();

				// Release the existing object URL, and the anchor
				setTimeout(function ()
				{
					URL.revokeObjectURL(downloadUrl);

					dispatchEvent('afterDownload', {'blob': blob, 'fileName': fileName});
				}, 100);
			}
		}
		else
		{
			dispatchEvent('beforeDownload', {'url': url});

			var xhr = new XMLHttpRequest();

			xhr.open('GET', url, true);

			xhr.responseType = 'blob';

			xhr.onload = function (e)
			{
				if ((this as any).status == 200)
				{
					if (!fileName)
					{
						var contentDisposition = (this as any).getResponseHeader('Content-Disposition');

						if (contentDisposition && contentDisposition.indexOf('filename='))
						{
							fileName = contentDisposition.right('filename=');
							if (fileName && fileName.indexOf('"') > -1)
							{
								fileName = fileName.right('"').left('"');
							}
						}
						else
						{
							fileName = url.backwardsRight('/');
						}
					}

					_download(new Blob([(this as any).response], {type: (this as any).response.type}), fileName);
				}
				else
				{
					fallback(url);
				}

				dispatchEvent('afterDownload', {'url': url});
			};

			xhr.send();
		}
		;

	}
	catch (ex)
	{
		if (console)
		{
			console.log(ex);
		}

		if (url instanceof String)
		{
			fallback(url.toString());
		}

		throw ex;
	}
}

/**
 * Usage: download(url)
 *
 * Downloads the file in the background. Falls back to a regular file download if AJAX is unavailable.
 *
 * @param url The URL of the file to download.
 */
export function download(url: string, filename?: string): void
{
	_download(url, filename);
}